export default "__VITE_ASSET__DdUGhLHG__"